import { render, staticRenderFns } from "./FiltersBox.vue?vue&type=template&id=2fc24e08&scoped=true"
import script from "./FiltersBox.vue?vue&type=script&lang=js"
export * from "./FiltersBox.vue?vue&type=script&lang=js"
import style0 from "./FiltersBox.vue?vue&type=style&index=0&id=2fc24e08&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc24e08",
  null
  
)

export default component.exports